/**
 * @file     DisclosureBlock.tsx
 * @purpose  Renders a content-engine disclosure block as muted fine print under a hairline rule.
 */
'use client';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useAppTheme } from '@/core/theme/useAppTheme';
import type { ContentBlock } from '@/services/content-engine/types';

type DisclosureBlockProps = Extract<ContentBlock, { t: 'disclosure' }>;

export const DisclosureBlock = ({ text }: DisclosureBlockProps) => {
  const { theme } = useAppTheme();

  if (!text) return null;

  return (
    <Box sx={{ borderTop: `1px solid ${theme.semanticColors.borderSubtle}`, pt: '16px' }}>
      <Typography
        sx={{
          fontSize: theme.typography.caption,
          lineHeight: 1.6,
          color: theme.semanticColors.textMuted,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};
